import React from "react";
import { FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, FormHelperText } from "@mui/material";
import { error } from "jquery";

const ReusableRadioGroup = ({ label, options, value, onChange, error, helperText, requireValue }) => {
  const errorStyle = { color: error ? '#d32f2f' : '#4C4E64' }
  return (
    <FormControl sx={{ my: "10px" }} error={error} required={requireValue}>
      <FormLabel sx={{ fontWeight: "bold", color: "#3D3D3D", fontSize: '14px' }}>{label}</FormLabel>
      <RadioGroup row value={value} onChange={(e) => onChange(e, options)}>
        {options.map((option) => (
          <FormControlLabel
            key={option.id}
            value={option.value}
            control={<Radio sx={errorStyle} />}
            label={option.Name} 
            sx={errorStyle}
          />
        ))}
      </RadioGroup>
      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  );
};

export default ReusableRadioGroup;
